export enum SAVED_QUOTES_EXACT_TARGET_TEMPLATES {
    PRODUCER_SHARED_MEDICARE_BLANK = "ProducerSharedMedicareBlank",
    PRODUCER_DOCUMENT_UPLOAD_REQUEST = "ProducerIndividualMarketDocRequest"
}
